// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"733":"1eed4b","895":"be5002"}[chunkId] + ".css";
};